<nb-card class="new-client-dialog">
    <nb-card-header>
        <h1>{{ 'addnewclient' | translate }}</h1>
        <h3>{{ 'searchorgforclient' | translate }}</h3>
    </nb-card-header>
    <nb-card-body>
        <div *ngIf="existing.length" class="existing-clients">
            <p>{{ 'alreadyyourclient' | translate }}</p>
            <button *ngFor="let c of existing" nbButton size="small" status="basic" type="button" (click)="pickExisting(c)">
                {{ c.name }}
            </button>
        </div>
        <bst-list-adder
            target="organization"
            [autolist]="true"
            [single]="true"
            [saveunknown]="false"
            [addnew]="addBlankClient"
            [formControl]="pickerControl"
            [placeholder]="'searchorg' | translate">
        </bst-list-adder>

        <div *ngIf="errorMessage" class="error-banner">{{ errorMessage }}</div>
    </nb-card-body>
    <nb-card-footer>
        <button nbButton type="button" (click)="cancel()" [disabled]="saving">{{ 'cancel' | translate }}</button>
        <button nbButton type="button" status="primary" (click)="trackAsProspect()" [disabled]="!picked || saving">
            {{ 'trackasprospect' | translate }}
        </button>
        <button nbButton type="button" status="success" (click)="addAsClient()" [disabled]="!picked || saving">
            {{ 'addasclient' | translate }}
        </button>
    </nb-card-footer>
</nb-card>
